import { useState } from "react";

import { useModal } from "@common/components/Modal/Modal";
import { helpCenterArticles } from "@common/util/helpCenterArticles";
import { showIntercomArticle } from "@common/util/intercom";
import { useUserFeedbackDiscardNewTicketModal } from "@main/pages/UserFeedback/views/UserFeedbackAddNewTicketView/useUserFeedbackDiscardNewTicketModal";

interface Props {
  refetchData: () => void;
}

export const useUserFeedbackAddNewTicketModal = ({ refetchData }: Props) => {
  const [isCreateAnotherTicket, setCreateAnotherTicket] = useState(false);
  const [shouldShowDiscardModal, setShouldShowDiscardModal] = useState(false);

  const {
    Modal: AddNewTicketModal,
    setActive: setAddNewTicketModalActive,
    modalProps: addNewTicketModalProps,
    active,
  } = useModal({
    size: "wide",
    hash: "#add-ticket",
    onOutsideClick: shouldShowDiscardModal
      ? () => discardNewTicketModal.setDiscardNewTicketModalActive(true)
      : undefined,
  });

  const discardNewTicketModal = useUserFeedbackDiscardNewTicketModal({
    setModalActive: setAddNewTicketModalActive,
  });

  const onTicketCreated = () => {
    refetchData();
    if (!isCreateAnotherTicket) setAddNewTicketModalActive(false);
  };

  const onDirtyChanged = (dirty: boolean) => {
    setShouldShowDiscardModal(dirty);
  };

  const onInfoClick = () => {
    showIntercomArticle(helpCenterArticles.manuallyAddingTickets);
  };

  return {
    active,
    setAddNewTicketModalActive,
    AddNewTicketModal,
    addNewTicketModalProps,
    setCreateAnotherTicket,
    isCreateAnotherTicket,
    onTicketCreated,
    onInfoClick,
    shouldShowDiscardModal,
    setShouldShowDiscardModal,
    discardNewTicketModal,
    onDirtyChanged,
  };
};
